module.exports = __webpack_public_path__ + "media/WhatsApp Video 2022-04-09 at 16.11.17.1b7874d6.mp4";